module.exports = __webpack_public_path__ + "static/media/sales-order-slide-10.ec6a7dea.jpg";